import { useReduxState } from 'hooks';
import { EditorBlockTextField } from 'components/editor/blocks';

interface Props {
  color: string;
  index: number;
  isPreview?: boolean;
  onChange: (index: number, value: string) => void;
  value: string;
}

const EditorBlockLikertOption = ({
  color = 'inherit',
  index,
  isPreview = false,
  onChange,
  value
}: Props) => {
  const { messages, theme } = useReduxState();

  const handleChange = (newValue: string) => {
    onChange(index, newValue);
  };

  return (
    <div className="option">
      {isPreview ? (
        <div
          style={{
            borderRadius: theme.inputBorderRadius,
            backgroundColor: 'white',
            padding: `7px 30px 7px ${index >= 9 ? '38px' : '30px'}`,
            width: 260
          }}
        >
          {value}
        </div>
      ) : (
        <EditorBlockTextField
          aria-label={messages.commonAddOption}
          onValueChange={handleChange}
          placeholder={messages.commonAddOption}
          style={{
            padding: `7px 30px 7px ${index >= 9 ? '38px' : '30px'}`,
            width: 260
          }}
          value={value}
        />
      )}

      <div
        aria-label={messages.editorBlockLikertColormapTooltip}
        data-tooltip={messages.editorBlockLikertColormapTooltip}
        className="color-sample"
      />

      <style jsx>{`
        .option {
          margin-bottom: 5px;
          width: 260px;
          position: relative;
        }
        .option:not(:first-child) {
          margin-top: 8px;
        }
        .option::before {
          content: '${index + 1}.';
          font-weight: 400;
          position: absolute;
          left: 13px;
          top: 8px;
          z-index: 1;
        }
        .color-sample {
          background-color: ${color};
          border-radius: 50%;
          height: 16px;
          width: 16px;
          z-index: 0;
          position: absolute;
          right: 8px;
          bottom: 9px;
        }
      `}</style>
    </div>
  );
};

export default EditorBlockLikertOption;
